// extracted by mini-css-extract-plugin
export var displayNone = "_qc-6";
export var imgContainer = "_qc-2";
export var overflowHidden = "_qc-3";
export var productInfoCardButtonContainer = "_qc-5";
export var productTitleText = "_qc-4";
export var rightArrow = "_qc-1";
export var rightArrowContainer = "_qc-0";